import script from "./CancellationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancellationModal.vue?vue&type=script&setup=true&lang=ts"

import "./CancellationModal.vue?vue&type=style&index=0&id=ef768688&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef768688"]])

export default __exports__